import { render, staticRenderFns } from "./sendmsg.vue?vue&type=template&id=7f02a189&scoped=true&"
import script from "./sendmsg.vue?vue&type=script&lang=js&"
export * from "./sendmsg.vue?vue&type=script&lang=js&"
import style0 from "./sendmsg.vue?vue&type=style&index=0&id=7f02a189&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f02a189",
  null
  
)

export default component.exports